
import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { jsPDF } from "jspdf";

export function ExamList({ onBack }) {
  const examLists = {
    Masculino: {
      hormonais: [
        "✔ Testosterona total e livre",
        "✔ Estradiol (E2)",
        "✔ LH (Hormônio Luteinizante)",
        "✔ FSH (Hormônio Folículo-Estimulante)",
        "✔ Prolactina",
        "✔ SHBG (Globulina Ligadora de Hormônios Sexuais)",
        "✔ DHT (Di-hidrotestosterona)",
        "✔ DHEA-S (Deidroepiandrosterona Sulfato)",
        "✔ Cortisol",
        "✔ TSH, T3 e T4 Livre",
      ],
      metabolicos: [
        "✔ Glicemia de jejum",
        "✔ Insulina basal",
        "✔ Hemoglobina glicada (HbA1c)",
        "✔ HOMA-IR (será calculado)",
        "✔ Colesterol Total",
        "✔ HDL (Colesterol bom)",
        "✔ LDL (Colesterol ruim)",
        "✔ VLDL",
        "✔ Triglicerídeos",
        "✔ Ácido Úrico",
        "✔ TGO/AST",
        "✔ TGP/ALT",
        "✔ Gama GT",
        "✔ Hemograma completo",
        "✔ Hematócrito",
        "✔ Hemoglobina",
        "✔ PSA total e livre (> 45 anos)",
        "✔ Vitamina D - 25(OH)D",
        "✔ Ferritina",
      ]
    },
    Feminino: {
      hormonais: [
        "✔ FSH (Hormônio Folículo-Estimulante)",
        "✔ LH (Hormônio Luteinizante)",
        "✔ Estradiol (E2)",
        "✔ Progesterona",
        "✔ Prolactina",
        "✔ SHBG (Globulina Ligadora de Hormônios Sexuais)",
        "✔ Testosterona livre",
        "✔ DHEA-S (Deidroepiandrosterona Sulfato)",
        "✔ Cortisol",
        "✔ TSH, T3 e T4 Livre",
        "✔ AMH (Hormônio Anti-Mülleriano) - Para avaliação da reserva ovariana",
      ],
      metabolicos: [
        "✔ Glicemia de jejum",
        "✔ Insulina basal",
        "✔ Hemoglobina glicada (HbA1c)",
        "✔ HOMA-IR (será calculado)",
        "✔ Colesterol Total",
        "✔ HDL (Colesterol bom)",
        "✔ LDL (Colesterol ruim)",
        "✔ VLDL",
        "✔ Triglicerídeos",
        "✔ Ácido Úrico",
        "✔ TGO/AST",
        "✔ TGP/ALT",
        "✔ Gama GT",
        "✔ Hemograma completo",
        "✔ Hematócrito",
        "✔ Hemoglobina",
        "✔ Vitamina D - 25(OH)D",
        "✔ Ferritina",
      ]
    }
  };

  const generatePDF = (gender) => {
    const doc = new jsPDF();
    
    // Configurações iniciais
    doc.setFontSize(22);
    doc.setTextColor("#ff3366");
    doc.text("Hormonal Axis", 105, 20, { align: "center" });
    
    doc.setFontSize(16);
    doc.setTextColor("#666666");
    doc.text("Lista de Exames Necessários", 105, 30, { align: "center" });
    
    doc.setFontSize(12);
    doc.text(`Gênero: ${gender}`, 20, 50);
    doc.text(`Data: ${new Date().toLocaleDateString()}`, 20, 60);
    
    // Exames Hormonais
    let yPos = 80;
    doc.setFontSize(14);
    doc.setTextColor("#ff3366");
    doc.text("Exames Hormonais:", 20, yPos);
    yPos += 10;
    doc.setFontSize(12);
    doc.setTextColor("#666666");
    
    examLists[gender].hormonais.forEach((exam) => {
      doc.text(exam, 20, yPos);
      yPos += 10;
    });
    
    // Exames Metabólicos
    yPos += 10;
    doc.setFontSize(14);
    doc.setTextColor("#ff3366");
    doc.text("Exames Metabólicos e Complementares:", 20, yPos);
    yPos += 10;
    doc.setFontSize(12);
    doc.setTextColor("#666666");
    
    examLists[gender].metabolicos.forEach((exam) => {
      doc.text(exam, 20, yPos);
      yPos += 10;
      
      if (yPos > 270) {
        doc.addPage();
        yPos = 20;
      }
    });
    
    // Observações
    yPos += 10;
    doc.setFontSize(14);
    doc.setTextColor("#ff3366");
    doc.text("Observações Importantes:", 20, yPos);
    yPos += 10;
    doc.setFontSize(12);
    doc.setTextColor("#666666");
    
    const observacoes = [
      "1. Jejum obrigatório de 8-12 horas",
      "2. Colher pela manhã (entre 7-9h)",
      "3. Evitar exercícios físicos 24h antes",
      "4. Evitar bebidas alcoólicas 72h antes",
      "5. Informar medicamentos em uso",
      "6. Mulheres: anotar dia do ciclo menstrual",
    ];

    observacoes.forEach((obs) => {
      doc.text(obs, 20, yPos);
      yPos += 7;
    });
    
    // Footer
    doc.setFontSize(10);
    doc.setTextColor("#999999");
    doc.text("Powered by Tech4Life.pro", 105, 280, { align: "center" });
    
    doc.save("exames-hormonais.pdf");
  };

  return (
    <motion.div
      className="mt-10 max-w-2xl mx-auto"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex items-center gap-4 mb-6">
        <Button
          onClick={onBack}
          variant="ghost"
          className="text-[#ff3366] hover:text-[#ff3366]/80 hover:bg-[#1a1a2e]"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar
        </Button>
        <h2 className="text-xl font-bold text-[#ff3366]">
          Lista de Exames Necessários
        </h2>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 300 }}
          className="rounded-lg bg-[#1a1a2e]/50 p-6 shadow-lg backdrop-blur-sm border border-[#ff3366]/20"
        >
          <h3 className="text-xl font-semibold text-[#ff3366] mb-4">
            Masculino
          </h3>
          <Button
            onClick={() => generatePDF("Masculino")}
            className="w-full bg-[#ff3366] hover:bg-[#ff3366]/80"
          >
            Baixar Lista
          </Button>
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.02 }}
          transition={{ type: "spring", stiffness: 300 }}
          className="rounded-lg bg-[#1a1a2e]/50 p-6 shadow-lg backdrop-blur-sm border border-[#ff3366]/20"
        >
          <h3 className="text-xl font-semibold text-[#ff3366] mb-4">
            Feminino
          </h3>
          <Button
            onClick={() => generatePDF("Feminino")}
            className="w-full bg-[#ff3366] hover:bg-[#ff3366]/80"
          >
            Baixar Lista
          </Button>
        </motion.div>
      </div>
    </motion.div>
  );
}
